/**
 * Command action types
 */
export const OPEN_LINK_VIEW_MODAL = '[application] OPEN_LINK_VIEW_MODAL';
export const CLOSE_LINK_VIEW_MODAL = '[application] CLOSE_LINK_VIEW_MODAL';

/**
 * Event action types
 */

/**
 * Store action types
 */
export const STORE_LINKS = '[application] STORE_LINKS';

export const SET_SPORT_ID = '[application] SET_SPORT_ID';

export const START_FEEDBACK_REQUEST = '[application] START_FEEDBACK_REQUEST';
export const SEND_FEEDBACK_REQUEST = '[application] SEND_FEEDBACK_REQUEST';
export const SEND_FEEDBACK_SUCCESS = '[application] SEND_FEEDBACK_SUCCESS';
export const SEND_FEEDBACK_ERROR = '[application] SEND_FEEDBACK_ERROR';
export const SEND_FEEDBACK_REQUEST_FAILED = '[application] SEND_FEEDBACK_REQUEST_FAILED';
export const SEND_FEEDBACK_REQUEST_SUCCEEDED = '[application] SEND_FEEDBACK_REQUEST_SUCCEEDED';

export const RESET_FEEDBACK = '[application] RESET_FEEDBACK';

export const STORE_FEEDBACK_RESPONSE = '[application] STORE_FEEDBACK_RESPONSE';
